<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Campaign</h1>
      <breadcrumb name="LUCKY_DRAW_CAMPAIGN"></breadcrumb>
      <div class="page-header-actions">
        <button
          type="button"
          class="btn btn-icon btn-dark btn-outline btn-round mx-10"
          @click="reloadTable"
        >
          <i class="icon md-refresh-alt" aria-hidden="true"></i> Reload table
        </button>

        <button
          type="button"
          class="btn btn-round btn-dark btn-outline mx-10"
          @click="hideArchive = !hideArchive"
        >
          {{ hideArchive ? "Show all" : "Hide Archive" }}
        </button>

        <button
          type="button"
          class="btn btn-round btn-primary"
          @click="openCreateModal"
        >
          <i class="icon md-plus" aria-hidden="true"></i> Create
        </button>
      </div>
    </div>
    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              :columns="columns"
              :rows="list"
              @on-row-click="onRowDoubleClick"
              :sort-options="sortOption"
              :search-options="searchOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field == 'end_date'">
                  {{ props.row.end_date == null ? "n/a" : props.row.end_date }}
                </div>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <modal name="create-modal" :width="900" height="auto">
      <CreateModal @submit="fetchcampaign" />
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import { luckyDrawService } from "@/api/client";
import vueGoodTableMixins from "@/mixins/vue-good-table";
import CreateModal from "@/views/luckydraw/CreateModal.vue";
import { campaignTableColumns } from "@/views/luckydraw/model";

export default {
  name: "CampaignList",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      campaigns: [],
      hideArchive: true,
      columns: campaignTableColumns,
    };
  },

  components: { CreateModal },

  created() {
    this.fetchcampaign();
  },

  watch: {
    hideArchive() {
      this.filter();
    },

    campaigns(v) {
      this.list = v.map((c) => {
        return Object.assign({}, c, {
          duration: this.getDuration(c.start_date, c.end_date) + 1,
        });
      });
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  methods: {
    onRowDoubleClick(event) {
      this.$router
        .push({ name: "LuckyDrawEdit", params: { id: event.row.id } })
        .catch((err) => {});
    },

    async fetchcampaign(show_all) {
      this.campaigns = await luckyDrawService.getCampaignList({
        show_all: show_all,
      });
    },

    filter() {
      this.hideArchive
        ? (this.campaigns = this.fetchcampaign(0))
        : (this.campaigns = this.fetchcampaign(1));
    },

    async reloadTable() {
      await this.fetchcampaign();
      this.$notify("Updated");
    },

    async openCreateModal() {
      this.$modal.show(`create-modal`);
    },

    getDuration(start, end) {
      return moment(end).diff(start, "days");
    },
  },
};
</script>

<style lang="scss">
table.vgt-table tr {
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
